import { Link, useParams } from 'react-router-dom';
import { api } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import { Avatar } from '@/components/Avatar';
import { Topbar } from '@/components/Topbar';
import { EmptyState } from '@/components/EmptyState';
import { fmtRelative } from '@/lib/format';

const KIND = { dm: 'ЛС', mention: 'упом.', reply: 'reply' };

export function CampaignInboxPage(): JSX.Element {
  const { id } = useParams();
  const cid = Number(id);
  const { data, loading } = useAsync(() => api.listInboxThreads(cid), [cid]);

  return (
    <div className="space-y-3">
      <Topbar title="Inbox" subtitle={`${data?.length ?? 0} переписок`} />

      {loading && (
        <div className="space-y-2"><div className="skeleton h-20" /><div className="skeleton h-20" /></div>
      )}

      {!loading && (data ?? []).length === 0 && (
        <EmptyState icon="inbox" title="Тишина" body="Когда кто-то напишет в ЛС или упомянёт ваш аккаунт — появится здесь." />
      )}

      <ul className="space-y-2">
        {(data ?? []).map((t) => (
          <li key={t.id}>
            <Link
              to={`/campaigns/${cid}/inbox/${encodeURIComponent(t.id)}`}
              className="card flex items-center gap-3 p-3 transition active:scale-[0.99]"
            >
              <Avatar name={t.fromName} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="truncate text-sm font-semibold text-ink-50">{t.fromName}</span>
                  <span className="pill pill-primary shrink-0">{KIND[t.kind]}</span>
                </div>
                <div className="mt-0.5 truncate text-xs text-ink-300">{t.preview}</div>
                <div className="mt-0.5 text-2xs text-ink-500">
                  {t.fromUsername && `${t.fromUsername} · `}
                  {fmtRelative(t.lastAt)} · от {t.accountUsername}
                </div>
              </div>
              {t.unreadCount > 0 && (
                <span className="ml-auto inline-flex h-6 min-w-[24px] shrink-0 items-center justify-center rounded-full bg-accent-500 px-1.5 text-2xs font-bold text-white">
                  {t.unreadCount}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
